import { css, cx } from '@emotion/css';

import withControl, { WithControlRenderProps } from '../withControl';

import { COLORS, SUGGESTIONS } from './constants';
import {
  labelClassName,
  suggestionClassName,
  suggestionsClassName,
} from './styles';

interface OwnProps {
  className?: string;
  suggestions?: string[];
}

type Props = OwnProps & WithControlRenderProps;

const HeadlineSuggestions = ({ className, onChange, ref, suggestions }: Props) => {
  return (
    <div className={cx(suggestionsClassName, className)} ref={ref}>
      {(suggestions ?? SUGGESTIONS).map((suggestion, i) => (
        <div
          key={i}
          className={cx(suggestionClassName, css(COLORS[i]))}
          onClick={() => onChange(suggestion)}
        >
          <span className={labelClassName}>{suggestion}</span>
        </div>
      ))}
    </div>
  );
};

HeadlineSuggestions.displayName = 'HeadlineSuggestions';

export default withControl(HeadlineSuggestions);
